import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useHistory, Link } from 'react-router-dom';
import Select from 'react-select';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Button, CircularProgress, IconButton, Checkbox
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CopyrightIcon from '@mui/icons-material/Copyright';
// Assume fetchData and postData are defined elsewhere
import { fetchData, updateData, postData } from '../../../apiService';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';

const QuotationEdit = () => {
    const history = useHistory();
    // const companyId = 2;
    // const userId = 1;
    const { id } = useParams();
    const [selectedItems, setSelectedItems] = useState([]);
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchUOM();
        fetchGSTRate();
    }, [isAuthenticated, companyId, token]);

    // Date Format 
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // const [formData, setFormData] = useState({
    //     CompanyId: companyId,
    //     CustomerId: '',
    //     QuotationPrefix: 'QO/FMN',
    //     QuotationNumber: '',
    //     FinYear: '',
    //     QuotationDate: '',
    //     Amount: '',
    //     TaxableAmount: '',
    //     GSTRate: '0',
    //     GSTAmount: '',
    //     CGSTAmount: '',
    //     SGSTAmount: '',
    //     IGSTAmount: '',
    //     RoundOff: '',
    //     TotalAmount: '',
    //     Remarks: '',
    //     CreatedBy: userId,
    //     CreatedDate: new Date().toISOString(),
    // });

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData(prev => ({ ...prev, [name]: value }));
    // };

    // const [CustomerOptions, setCustomerOptions] = useState([]);
    // const [selectedCustomer, setSelectedCustomer] = useState("");
    // const fetchCustomer = async () => {
    //     try {
    //         const res = await fetchData('QuotationApi', `/Customer/${companyId}`, token);
    //         if (res.responseCode === '1111') {
    //             const options = res.response_data.map(c => ({ value: c.Id, label: c.Name }));
    //             setCustomerOptions(options);
    //         }
    //     } catch (e) { console.error('Error fetching Customer:', e); }
    // };
    // //const [selectedCustomer, setSelectedCustomer] = useState({});

    // const [fetchedCustomerDetails, setFetchedCustomerDetails] = useState([]);
    // const handleCustomerChange = async (opt) => {
    //     setSelectedCustomer(opt);
    //     setFormData(prev => ({ ...prev, CreatedBy: userId, CompanyId: companyId, CustomerId: opt.value }));
    //     try {
    //         const res = await fetchData('CustomerApi', `/CustomerDetails/${opt.value}`, token);
    //         if (res.responseCode === '1111') {
    //             setFetchedCustomerDetails(res.response_data);
    //         }
    //     } catch (e) {
    //         console.error('Error fetching Customer details:', e);
    //     }
    // };

    // const [WorkOptions, setWorkOptions] = useState([]);
    // const [selectedWork, setSelectedWork] = useState(null);
    // const [workId, setWorkId] = useState("");
    // const [fetchedWorkDetails, setFetchedWorkDetails] = useState([]);

    // const fetchWork = async () => {
    //     try {
    //         const res = await fetchData('QuotationApi', `/Work/${companyId}`, token);
    //         if (res.responseCode === '1111') {
    //             const options = res.response_data.map(w => ({ value: w.Id, label: w.Name }));
    //             setWorkOptions(options);
    //         }
    //     } catch (e) { console.error('Error fetching work:', e); }
    // };

    // const handleWorkChange = async (opt) => {
    //     setSelectedWork(opt);
    //     setWorkId(opt.value);
    //     try {
    //         const res = await fetchData('QuotationApi', `/WorkDetails/${opt.value}`, token);
    //         if (res.responseCode === '1111') {
    //             setFetchedWorkDetails(res.response_data);
    //         }
    //     } catch (e) {
    //         console.error('Error fetching work details:', e);
    //     }
    // };

    // const [selectedWorkDetails, setSelectedWorkDetails] = useState([]);

    // // const handleAddWork = () => {
    // //     if (fetchedWorkDetails.length === 0) return;
    // //     setSelectedWorkDetails(prev => [...prev, ...fetchedWorkDetails]);
    // //     setFetchedWorkDetails([]);
    // //     setSelectedWork(null);
    // // };


    // const openConfirmDialog = (index) => {
    //     const updated = [...selectedWorkDetails];
    //     updated.splice(index, 1);
    //     setSelectedWorkDetails(updated);
    // };

    // //const [groupedData, setGroupedData] = useState({});

    // useEffect(() => {
    //     const grouped = selectedWorkDetails.reduce((acc, item) => {
    //         if (!acc[item.WorkName]) acc[item.WorkName] = [];
    //         acc[item.WorkName].push(item);
    //         return acc;
    //     }, {});
    //     setGroupedData(grouped);
    // }, [selectedWorkDetails]);

    // // const handleCalculation = (e, workName, localIndex, field) => {
    // //     const value = e.target.value;

    // //     // Find the global index of this item in flat list
    // //     let globalIndex = 0;
    // //     let found = false;

    // //     for (const [group, items] of Object.entries(groupedData)) {
    // //         if (group === workName) {
    // //             globalIndex += localIndex;
    // //             found = true;
    // //             break;
    // //         }
    // //         globalIndex += items.length;
    // //     }

    // //     if (!found) return;

    // //     setSelectedWorkDetails((prev) => {
    // //         const updated = [...prev];
    // //         const item = { ...updated[globalIndex] };

    // //         item[field] = value === "" ? "" : parseFloat(value);

    // //         const qty = parseFloat(item.Quantity) || 0;
    // //         const rate = parseFloat(item.Rate) || 0;
    // //         item.Amount = parseFloat((qty * rate).toFixed(2));

    // //         item.TaxableAmount = item.Amount;

    // //         const gstRate = parseFloat(item.GSTRate) || 0;
    // //         const gstAmount = parseFloat(((item.Amount * gstRate) / 100).toFixed(2));

    // //         item.CGSTAmount = gstAmount / 2;
    // //         item.SGSTAmount = gstAmount / 2;
    // //         item.IGSTAmount = 0;

    // //         item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));

    // //         updated[globalIndex] = item;
    // //         return updated;
    // //     });
    // // };

    // const handleCalculation = (e, workName, localIndex, field) => {
    //     const raw = e.target.value;
    //     const value = raw === "" ? "" : parseFloat(raw);

    //     // map local index to global index
    //     let globalIndex = 0;
    //     let found = false;
    //     for (const [group, items] of Object.entries(groupedData)) {
    //         if (group === workName) {
    //             globalIndex += localIndex;
    //             found = true;
    //             break;
    //         }
    //         globalIndex += items.length;
    //     }
    //     if (!found) return;

    //     setSelectedWorkDetails((prev) => {
    //         const arr = [...prev];
    //         const item = { ...arr[globalIndex] };

    //         item[field] = value;

    //         const qty = parseFloat(item.Quantity) || 0;
    //         const rate = parseFloat(item.Rate) || 0;
    //         item.Amount = parseFloat((qty * rate).toFixed(2));
    //         item.TaxableAmount = item.Amount;

    //         const gstRate = parseFloat(item.GSTRate) || 0;
    //         const gstAmount = parseFloat(((item.Amount * gstRate) / 100).toFixed(2));

    //         item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    //         item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    //         item.IGSTAmount = 0;
    //         item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));

    //         arr[globalIndex] = item;
    //         return arr;
    //     });
    // };


    // // Including Tax
    // // const handleCalculation = (e, workName, localIndex, field) => {
    // //     const value = e.target.value;

    // //     // Find the global index of this item in flat list
    // //     let globalIndex = 0;
    // //     let found = false;

    // //     for (const [group, items] of Object.entries(groupedData)) {
    // //         if (group === workName) {
    // //             globalIndex += localIndex;
    // //             found = true;
    // //             break;
    // //         }
    // //         globalIndex += items.length;
    // //     }

    // //     if (!found) return;

    // //     setSelectedWorkDetails((prev) => {
    // //         const updated = [...prev];
    // //         const item = { ...updated[globalIndex] };

    // //         item[field] = value === "" ? "" : parseFloat(value);

    // //         const qty = parseFloat(item.Quantity) || 0;
    // //         const gstRate = parseFloat(item.GSTRate) || 0;
    // //         const rateInclusive = parseFloat(item.Rate) || 0;

    // //         // Calculate base rate (excluding GST)
    // //         const rateExclusive = rateInclusive / (1 + gstRate / 100);
    // //         const amount = parseFloat((qty * rateExclusive).toFixed(2));

    // //         item.Amount = amount;
    // //         item.TaxableAmount = amount;

    // //         const gstAmount = parseFloat(((amount * gstRate) / 100).toFixed(2));

    // //         item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    // //         item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    // //         item.IGSTAmount = 0;

    // //         item.TotalAmount = parseFloat((amount + gstAmount).toFixed(2));

    // //         updated[globalIndex] = item;
    // //         return updated;
    // //     });
    // // };

    // const formatDateForInput = (dateString) => {
    //     const d = new Date(dateString);
    //     return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    // };

    // useEffect(() => {
    //     fetchCustomer();
    //     fetchWork();
    // }, []);

    // const [searchQuery, setSearchQuery] = useState('');
    // const [isFocused, setIsFocused] = useState(false);
    // const handleSearch = (event) => setSearchQuery(event.target.value);

    // const filteredData = selectedWorkDetails.filter((item) =>
    //     Object.values(item).some((val) =>
    //         String(val).toLowerCase().includes(searchQuery.toLowerCase())
    //     )
    // );

    // useEffect(() => {
    //     const totals = selectedWorkDetails.reduce(
    //         (acc, item) => {
    //             const amt = parseFloat(item.Amount) || 0;
    //             const taxAmt = parseFloat(item.TaxableAmount) || 0;
    //             const cgst = parseFloat(item.CGSTAmount) || 0;
    //             const sgst = parseFloat(item.SGSTAmount) || 0;
    //             const igst = parseFloat(item.IGSTAmount) || 0;
    //             const gst = cgst + sgst + igst;
    //             const total = parseFloat(item.TotalAmount) || 0;

    //             acc.Amount += amt;
    //             acc.TaxableAmount += taxAmt;
    //             acc.CGSTAmount += cgst;
    //             acc.SGSTAmount += sgst;
    //             acc.IGSTAmount += igst;
    //             acc.GSTAmount += gst;
    //             acc.TotalAmount += total;
    //             return acc;
    //         },
    //         {
    //             Amount: 0,
    //             TaxableAmount: 0,
    //             CGSTAmount: 0,
    //             SGSTAmount: 0,
    //             IGSTAmount: 0,
    //             GSTAmount: 0,
    //             TotalAmount: 0,
    //         }
    //     );

    //     const roundOff = +(totals.TotalAmount - Math.round(totals.TotalAmount)).toFixed(2);
    //     const grandTotal = Math.round(totals.TotalAmount);

    //     setFormData((prev) => ({
    //         ...prev,
    //         Amount: totals.Amount.toFixed(2),
    //         TaxableAmount: totals.TaxableAmount.toFixed(2),
    //         CGSTAmount: totals.CGSTAmount.toFixed(2),
    //         SGSTAmount: totals.SGSTAmount.toFixed(2),
    //         IGSTAmount: totals.IGSTAmount.toFixed(2),
    //         GSTAmount: totals.GSTAmount.toFixed(2),
    //         RoundOff: roundOff,
    //         TotalAmount: totals.TotalAmount.toFixed(2),
    //         GrandTotal: grandTotal.toFixed(2),
    //     }));
    // }, [selectedWorkDetails]);

    // const filteredGroupedData = Object.entries(groupedData).reduce((acc, [workName, items]) => {
    //     const filteredItems = items.filter(item =>
    //         Object.values(item).some(val =>
    //             String(val).toLowerCase().includes(searchQuery.toLowerCase())
    //         )
    //     );

    //     if (filteredItems.length > 0) {
    //         acc[workName] = filteredItems;
    //     }

    //     return acc;
    // }, {});

    // const [expandedGroups, setExpandedGroups] = useState({});

    // useEffect(() => {
    //     // Only once on component mount
    //     const initialExpanded = {};
    //     Object.keys(groupedData).forEach(work => {
    //         initialExpanded[work] = true;
    //     });
    //     setExpandedGroups(initialExpanded);
    // }, []); // <-- ✅ Empty dependency array

    // const toggleGroup = (workName) => {
    //     setExpandedGroups(prev => ({
    //         ...prev,
    //         [workName]: !prev[workName]
    //     }));
    // };

    // const handleAddWork = () => {
    //     if (fetchedWorkDetails.length === 0) return;

    //     const updatedFetched = fetchedWorkDetails.map(item => ({
    //         ...item,
    //         WorkDetailsId: item.Id, // 🔁 Map Id to WorkId
    //         Id: 0,
    //     }));

    //     setSelectedWorkDetails(prev => [...prev, ...updatedFetched]);
    //     setFetchedWorkDetails([]);
    //     setSelectedWork(null);

    //     const newGrouped = { ...groupedData };
    //     const newExpanded = { ...expandedGroups };
    //     const existingGroupKeys = Object.keys(groupedData);

    //     updatedFetched.forEach((item) => {
    //         const workName = item.WorkName;

    //         if (!newGrouped[workName]) {
    //             newGrouped[workName] = [];
    //         }

    //         newGrouped[workName].push(item);

    //         if (!existingGroupKeys.includes(workName)) {
    //             newExpanded[workName] = true;
    //         }
    //     });

    //     setGroupedData(newGrouped);
    //     setExpandedGroups(newExpanded);
    // };

    // ---------- UI / form states ----------
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [searchQuery, setSearchQuery] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const handleSearch = (event) => setSearchQuery(event.target.value);

    // ---------- QA Child Detail Name and Terms & Conditions states ----------
    const [qaChildDetailName, setQaChildDetailName] = useState("");
    const [termsListQA, setTermsListQA] = useState([]);
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const [data, setData] = useState([]);

    // ---------- Select data ----------
    const [CustomerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [fetchedCustomerDetails, setFetchedCustomerDetails] = useState([]);

    const [WorkOptions, setWorkOptions] = useState([]);
    const [selectedWork, setSelectedWork] = useState(null);
    const [workId, setWorkId] = useState("");

    const [workitemdetailsOptions, setWorkItemDetailsOptions] = useState([]);
    const [selectedWorkItemDetails, setSelectedWorkItemDetails] = useState(null);
    const [fetchedWorkDetails, setFetchedWorkDetails] = useState([]); // keep raw API rows here

    // ---------- Table / grouping ----------
    const [selectedWorkDetails, setSelectedWorkDetails] = useState([]);
    const [groupedData, setGroupedData] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({});

    // ---------- Form data ----------
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        CustomerId: "",
        QuotationDate: new Date().toISOString().slice(0, 10), // yyyy-mm-dd for <input type="date" />
        QuotationNumber: "",
        FinYear: "",
        IsRevised: false,
        Amount: "",
        TaxableAmount: "",
        GSTRate: "0",
        GSTAmount: "",
        CGSTAmount: "",
        SGSTAmount: "",
        IGSTAmount: "",
        RoundOff: "0.00",
        TotalAmount: "",
        GrandTotal: "",
        Remarks: "",
        Description: "",
        CreatedBy: userId,
        CreatedDate: new Date().toISOString(),
    });

    // ---------- Effects: Initial fetch ----------
    useEffect(() => {
        const init = async () => {
            try {
                // Customers
                const c = await fetchData("QuotationApi", `/Customer/${companyId}`, token);
                if (c?.responseCode === "1111") {
                    setCustomerOptions(
                        c.response_data.map((x) => ({ value: x.Id, label: x.Name }))
                    );
                }

                // Works
                const w = await fetchData("QuotationApi", `/Work/${companyId}`, token);
                if (w?.responseCode === "1111") {
                    setWorkOptions(
                        w.response_data.map((x) => ({ value: x.Id, label: x.Name }))
                    );
                }
            } catch (e) {
                console.error("Init fetch error:", e);
            }
        };
        init();
    }, [companyId, token]);

    // ---------- Handlers: customer ----------
    const handleCustomerChange = async (opt) => {
        setSelectedCustomer(opt);
        setFormData((prev) => ({
            ...prev,
            CreatedBy: userId,
            CompanyId: companyId,
            CustomerId: opt?.value || "",
        }));

        if (!opt?.value) {
            setFetchedCustomerDetails([]);
            return;
        }

        try {
            const res = await fetchData("CustomerApi", `/CustomerDetails/${opt.value}`, token);
            if (res?.responseCode === "1111") {
                setFetchedCustomerDetails(res.response_data);
            }
        } catch (e) {
            console.error("Error fetching Customer details:", e);
        }
    };

    // ---------- Handlers: work & details ----------
    const handleWorkChange = async (opt) => {
        setSelectedWork(opt);
        setWorkId(opt?.value || "");

        if (!opt?.value) {
            setFetchedWorkDetails([]);
            setWorkItemDetailsOptions([]);
            setSelectedWorkItemDetails(null);
            return;
        }

        try {
            // Get WorkDetails for the selected work
            const response = await fetchData("QuotationApi", `/WorkDetails/${opt.value}`, token);
            if (response?.responseCode === "1111") {
                const list = response.response_data || [];
                setFetchedWorkDetails(list); // raw rows for later mapping

                // Options for dropdown
                const options = list.map((wd) => ({
                    value: wd.Id,
                    label: `${wd.WorkItemName} / ${wd.Name} - ${wd.Description || ""}`,
                }));
                setWorkItemDetailsOptions(options);
            }
        } catch (error) {
            console.error("Error fetching WorkDetails:", error);
        }
    };

    const handleWorkItemDetailsChange = (selectedOption) => {
        setSelectedWorkItemDetails(selectedOption);
    };

    // ---------- ADD logic (respecting your style) ----------
    // const handleAddWork = () => {
    //     if (!selectedWork || !selectedWorkItemDetails) return;

    //     // find full object for the chosen detail
    //     const detailRow = fetchedWorkDetails.find((x) => x.Id === selectedWorkItemDetails.value);
    //     if (!detailRow) return;

    //     // shape the row for table (aligning with your calc fields)
    //     const item = {
    //         // linkage
    //         workId: detailRow.WorkId,
    //         WorkItemId: detailRow.WorkItemId,
    //         WorkDetailsId: detailRow.Id,
    //         UnitofMeasuresId: detailRow.UnitofMeasuresId,
    //         // grouping
    //         WorkName: detailRow.WorkName || selectedWork.label,
    //         WorkItemName: detailRow.WorkItemName || "",
    //         Name: detailRow.Name || "",
    //         UOM: detailRow.UOM || "",
    //         // display / calc fields
    //         Description: detailRow.Description || "",
    //         Quantity: 1,
    //         Rate: parseFloat(detailRow.Rate || 0),
    //         Amount: parseFloat(detailRow.Rate || 0), // = qty(1) * rate
    //         TaxableAmount: parseFloat(detailRow.Rate || 0),
    //         GSTRate: parseFloat(detailRow.GSTRate || 0), // use server value if present else 0
    //         CGSTAmount: 0,
    //         SGSTAmount: 0,
    //         IGSTAmount: 0,
    //         TotalAmount: 0,
    //     };

    //     // compute GST split (CGST/SGST) and Total
    //     const gstAmount = parseFloat(((item.Amount * (item.GSTRate || 0)) / 100).toFixed(2));
    //     item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    //     item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    //     item.IGSTAmount = 0;
    //     item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));

    //     setSelectedWorkDetails((prev) => [...prev, item]);

    //     // auto-expand the new group
    //     setExpandedGroups((prev) => ({
    //         ...prev,
    //         [item.WorkName]: true,
    //     }));

    //     // clear only WorkItem selection (keep Work for faster adding)
    //     setSelectedWorkItemDetails(null);
    // };

    // ---------- Delete row ----------

    const openConfirmDialog = (localIndexInGroup, workName) => {
        // translate group-local index to global index in selectedWorkDetails
        let globalIndex = 0;
        let found = false;

        for (const [group, items] of Object.entries(groupedData)) {
            if (group === workName) {
                globalIndex += localIndexInGroup;
                found = true;
                break;
            }
            globalIndex += items.length;
        }
        if (!found) return;

        setSelectedWorkDetails((prev) => {
            const next = [...prev];
            next.splice(globalIndex, 1);
            return next;
        });
    };

    // ---------- Delete item (nested structure) ----------
    const deleteItem = (qaName, workName, index) => {
        if (!window.confirm("Are you sure you want to delete this item?")) {
            return;
        }

        const quotationKey = "QuotationDetails";

        // Get the item to delete before updating state
        const itemToDelete = groupedData[quotationKey]?.[qaName]?.[workName]?.[index];
        if (!itemToDelete) return;

        // Update nested groupedData structure
        setGroupedData((prev) => {
            const updated = structuredClone(prev || {});

            // Navigate through nested structure to delete item
            if (!updated[quotationKey]?.[qaName]?.[workName]) {
                return prev;
            }

            // Remove the item at the specified index
            updated[quotationKey][qaName][workName].splice(index, 1);

            // Clean up empty work groups
            if (updated[quotationKey][qaName][workName].length === 0) {
                delete updated[quotationKey][qaName][workName];
            }

            // Clean up empty QA sections
            if (Object.keys(updated[quotationKey][qaName]).length === 0) {
                delete updated[quotationKey][qaName];
            }

            return updated;
        });

        // Also update the flat selectedWorkDetails array
        setSelectedWorkDetails((prev) => {
            return prev.filter((item) => {
                // Match by QA name, work name, and WorkDetailsId to ensure we delete the correct item
                if (
                    item.QAChildDetailName === qaName &&
                    item.WorkName === workName &&
                    item.WorkDetailsId === itemToDelete.WorkDetailsId
                ) {
                    // Check if this is the exact item by comparing other unique properties
                    // In case there are duplicates with same WorkDetailsId in the same group
                    return !(
                        item.Quantity === itemToDelete.Quantity &&
                        item.Rate === itemToDelete.Rate
                    );
                }
                return true; // Keep all other items
            });
        });
    };

    // ---------- Grouping (always from flat selectedWorkDetails) ----------
    useEffect(() => {
        const quotationKey = "QuotationDetails";
        const nested = { [quotationKey]: {} };

        selectedWorkDetails.forEach(item => {
            const qaName = item.QAChildDetailName || "Uncategorized";
            const workName = item.WorkName;

            if (!nested[quotationKey][qaName]) {
                nested[quotationKey][qaName] = {};
            }
            if (!nested[quotationKey][qaName][workName]) {
                nested[quotationKey][qaName][workName] = [];
            }

            nested[quotationKey][qaName][workName].push(item);
        });

        setGroupedData(nested);
    }, [selectedWorkDetails]);

    // ---------- Expand all groups when groupedData changes ----------
    useEffect(() => {
        const quotationKey = "QuotationDetails";

        // Only add new groups to expandedGroups, don't reset existing ones
        if (groupedData[quotationKey]) {
            setExpandedGroups((prev) => {
                const updated = { ...prev };

                Object.entries(groupedData[quotationKey]).forEach(([qaName, qaGroup]) => {
                    Object.keys(qaGroup).forEach((workName) => {
                        const key = `${qaName}_${workName}`;
                        // Only set to true if it doesn't exist yet (new group)
                        if (updated[key] === undefined) {
                            updated[key] = true;
                        }
                    });
                });

                return updated;
            });
        }
    }, [groupedData]);

    const toggleGroup = (qaName, workName) => {
        const key = `${qaName}_${workName}`;
        setExpandedGroups((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    // ---------- Search (filter inside table) ----------
    // Sub-task 12: Update filteredGroupedData logic to work with nested structure
    const filteredGroupedData = useMemo(() => {
        const quotationKey = "QuotationDetails";

        // If no search query, return the nested structure as-is
        if (!searchQuery) {
            return groupedData[quotationKey] || {};
        }

        const q = String(searchQuery).toLowerCase();
        const filtered = {};

        // Filter items within QA sections and work groups
        if (groupedData[quotationKey]) {
            Object.entries(groupedData[quotationKey]).forEach(([qaName, qaGroup]) => {
                const filteredQaGroup = {};

                Object.entries(qaGroup).forEach(([workName, items]) => {
                    // Filter items that match the search query
                    const filteredItems = items.filter((item) =>
                        Object.values(item).some((v) =>
                            String(v ?? "").toLowerCase().includes(q)
                        )
                    );

                    // Only include work groups that have matching items
                    if (filteredItems.length > 0) {
                        filteredQaGroup[workName] = filteredItems;
                    }
                });

                // Only include QA sections that have matching work groups
                if (Object.keys(filteredQaGroup).length > 0) {
                    filtered[qaName] = filteredQaGroup;
                }
            });
        }

        // Preserve nested structure in filtered result
        return filtered;
    }, [groupedData, searchQuery]);

    // ---------- Calculation on change (qty/rate/gst edits) ----------
    const handleCalculation = (e, qaName, workName, localIndex, field) => {
        const raw = e.target.value;
        const value = raw === "" ? "" : parseFloat(raw);

        const quotationKey = "QuotationDetails";

        // ✅ Update groupedData safely
        setGroupedData((prevData) => {
            const updated = structuredClone(prevData || {}); // deep clone

            if (!updated[quotationKey]) updated[quotationKey] = {};
            if (!updated[quotationKey][qaName]) updated[quotationKey][qaName] = {};
            if (!Array.isArray(updated[quotationKey][qaName][workName]))
                updated[quotationKey][qaName][workName] = [];

            const targetArray = updated[quotationKey][qaName][workName];

            if (targetArray[localIndex]) {
                const item = { ...targetArray[localIndex] };
                item[field] = value;

                // Recalculate amounts
                const qty = parseFloat(item.Quantity) || 0;
                const rate = parseFloat(item.Rate) || 0;
                item.Amount = parseFloat((qty * rate).toFixed(2));
                item.TaxableAmount = item.Amount;

                const gstRate = parseFloat(item.GSTRate) || 0;
                const gstAmount = parseFloat(((item.Amount * gstRate) / 100).toFixed(2));

                if (isIGST) {
                    // IGST mode: full GST goes to IGST
                    item.IGSTAmount = gstAmount;
                    item.CGSTAmount = 0;
                    item.SGSTAmount = 0;
                } else {
                    // Normal mode: split between CGST and SGST
                    item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
                    item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
                    item.IGSTAmount = 0;
                }
                item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));

                targetArray[localIndex] = item;
            }

            return updated;
        });

        // ✅ ALSO update selectedWorkDetails to keep it in sync
        setSelectedWorkDetails((prev) => {
            return prev.map((item) => {
                // Find the matching item by QA name, work name, and index
                if (item.QAChildDetailName === qaName && item.WorkName === workName) {
                    // Count items before this one in the same group to match localIndex
                    const itemsInGroup = prev.filter(
                        (x) => x.QAChildDetailName === qaName && x.WorkName === workName
                    );
                    const itemIndex = itemsInGroup.indexOf(item);

                    if (itemIndex === localIndex) {
                        const updatedItem = { ...item };
                        updatedItem[field] = value;

                        // Recalculate amounts
                        const qty = parseFloat(updatedItem.Quantity) || 0;
                        const rate = parseFloat(updatedItem.Rate) || 0;
                        updatedItem.Amount = parseFloat((qty * rate).toFixed(2));
                        updatedItem.TaxableAmount = updatedItem.Amount;

                        const gstRate = parseFloat(updatedItem.GSTRate) || 0;
                        const gstAmount = parseFloat(((updatedItem.Amount * gstRate) / 100).toFixed(2));

                        if (isIGST) {
                            // IGST mode: full GST goes to IGST
                            updatedItem.IGSTAmount = gstAmount;
                            updatedItem.CGSTAmount = 0;
                            updatedItem.SGSTAmount = 0;
                        } else {
                            // Normal mode: split between CGST and SGST
                            updatedItem.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
                            updatedItem.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
                            updatedItem.IGSTAmount = 0;
                        }
                        updatedItem.TotalAmount = parseFloat((updatedItem.Amount + gstAmount).toFixed(2));

                        return updatedItem;
                    }
                }
                return item;
            });
        });
    };

    // ---------- Totals aggregation ----------
    useEffect(() => {
        const quotationKey = "QuotationDetails";

        // Sub-task 8.1: Flatten nested structure for aggregation
        // Iterate through QuotationDetails → QA sections → Work groups → items
        const totals = {
            Amount: 0,
            TaxableAmount: 0,
            CGSTAmount: 0,
            SGSTAmount: 0,
            IGSTAmount: 0,
            GSTAmount: 0,
            TotalAmount: 0,
        };

        // Check if groupedData has the nested structure
        if (groupedData[quotationKey]) {
            // Iterate through QA sections
            Object.values(groupedData[quotationKey]).forEach((qaSection) => {
                // Iterate through Work groups within each QA section
                Object.values(qaSection).forEach((workGroup) => {
                    // Iterate through items within each Work group
                    workGroup.forEach((item) => {
                        const amt = parseFloat(item.Amount) || 0;
                        const taxAmt = parseFloat(item.TaxableAmount) || 0;
                        const cgst = parseFloat(item.CGSTAmount) || 0;
                        const sgst = parseFloat(item.SGSTAmount) || 0;
                        const igst = parseFloat(item.IGSTAmount) || 0;
                        const gst = cgst + sgst + igst;
                        const total = parseFloat(item.TotalAmount) || 0;

                        totals.Amount += amt;
                        totals.TaxableAmount += taxAmt;
                        totals.CGSTAmount += cgst;
                        totals.SGSTAmount += sgst;
                        totals.IGSTAmount += igst;
                        totals.GSTAmount += gst;
                        totals.TotalAmount += total;
                    });
                });
            });
        }

        // Sub-task 8.2: Calculate RoundOff and GrandTotal
        // Compute RoundOff as difference between rounded value and TotalAmount
        const roundOff = +(Math.round(totals.TotalAmount) - totals.TotalAmount).toFixed(2);
        // Calculate GrandTotal as rounded TotalAmount
        const grandTotal = Math.round(totals.TotalAmount);

        // Update formData with all calculated values
        setFormData((prev) => ({
            ...prev,
            Amount: totals.Amount.toFixed(2),
            TaxableAmount: totals.TaxableAmount.toFixed(2),
            CGSTAmount: totals.CGSTAmount.toFixed(2),
            SGSTAmount: totals.SGSTAmount.toFixed(2),
            IGSTAmount: totals.IGSTAmount.toFixed(2),
            GSTAmount: totals.GSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            TotalAmount: grandTotal.toFixed(2),//totals.TotalAmount.toFixed(2),
            GrandTotal: grandTotal.toFixed(2),
        }));
    }, [groupedData]);

    // ---------- Submit ----------

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ---------- Fetch UOM List ----------
    const [UomOptions, setUomOptions] = useState([]);
    const [selecteduom, setSelecteduom] = useState(null);

    const fetchUOM = async () => {
        try {
            const response = await fetchData('UOMApi', `/${companyId}`, token); //, token
            if (response.responseCode === '1111') {
                const options = response.response_data.map(uom => ({
                    value: uom.Id,
                    label: uom.Name
                }));
                setUomOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // ============================
    // TERMS & CONDITIONS
    // ============================
    const fetchTermsAndCondition = async () => {
        setIsLoading(true);
        try {
            const response = await fetchData("TermsAndConditionApi", `/${companyId}`, token);
            if (response.responseCode === "1111") {
                setData(response.response_data || []);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching Terms And Condition:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // Toggle modal open/close
    const LoadTermsAndConditions = () => {
        if (!isModalGrpOpen) {
            fetchTermsAndCondition();
        }
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    // Close modal
    const handleCloseModal = () => {
        setIsModalGrpOpen(false);
    };

    // Handle checkbox toggle
    const handleCheckboxChange = (item) => {
        console.log('Checkbox changed for item:', item);
        setSelectedItems((prev) => {
            console.log('Previous selectedItems:', prev);
            const exists = prev.some((x) => x.Id === item.Id);
            let updated;
            if (exists) {
                updated = prev.filter((x) => x.Id !== item.Id);
            } else {
                updated = [...prev, item];
            }
            console.log('Updated selectedItems:', updated);
            onSelectionChange(updated);
            return updated;
        });
    };

    // Check if item is selected
    const isItemSelected = (item) =>
        selectedItems.some((x) => x.Id === item.Id);

    // Update termsListQA when selection changes
    const onSelectionChange = (selected) => {
        setTermsListQA(selected);
    };

    // ============================

    // WORK DETAILS ADD & UOM FIX
    // ============================

    // const handleAddWork = () => {
    //     if (!selectedWork || !selectedWorkItemDetails) return;

    //     // find full object for the chosen detail
    //     const detailRow = fetchedWorkDetails.find(
    //         (x) => x.Id === selectedWorkItemDetails.value
    //     );
    //     if (!detailRow) return;

    //     // shape the row for table (aligning with your calc fields)
    //     const item = {
    //         // linkage
    //         workId: detailRow.WorkId,
    //         WorkItemId: detailRow.WorkItemId,
    //         WorkDetailsId: detailRow.Id,
    //         UnitofMeasuresId: detailRow.UnitofMeasuresId,

    //         // grouping
    //         WorkName: detailRow.WorkName || selectedWork.label,
    //         WorkItemName: detailRow.WorkItemName || "",
    //         Name: detailRow.Name || "",
    //         UOM: detailRow.UOM || "",

    //         // display / calc fields
    //         Description: detailRow.Description || "",
    //         Quantity: 1,
    //         Rate: parseFloat(detailRow.Rate || 0),
    //         Amount: parseFloat(detailRow.Rate || 0), // qty(1) * rate
    //         TaxableAmount: parseFloat(detailRow.Rate || 0),
    //         GSTRate: parseFloat(detailRow.GSTRate || 0),
    //         CGSTAmount: 0,
    //         SGSTAmount: 0,
    //         IGSTAmount: 0,
    //         TotalAmount: 0,
    //         Remarks: detailRow.Remarks || "",
    //     };

    //     // compute GST split (CGST/SGST) and Total
    //     const gstAmount = parseFloat(
    //         ((item.Amount * (item.GSTRate || 0)) / 100).toFixed(2)
    //     );
    //     item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    //     item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    //     item.IGSTAmount = 0;
    //     item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));

    //     // ✅ Append new item only (no refresh of existing)
    //     setSelectedWorkDetails((prev) => [...prev, item]);

    //     // ✅ Keep already edited data (UOM, etc.)
    //     setGroupedData((prev) => {
    //         const updated = { ...prev };
    //         const groupName = item.WorkName;

    //         if (!updated[groupName]) updated[groupName] = [];
    //         updated[groupName] = [...updated[groupName], item];

    //         return updated;
    //     });

    //     // ✅ auto-expand the new group
    //     setExpandedGroups((prev) => ({
    //         ...prev,
    //         [item.WorkName]: true,
    //     }));

    //     // ✅ clear only item dropdown (keep work)
    //     setSelectedWorkItemDetails(null);
    // };

    // const handleAddWork = () => {
    //     // Sub-task 4.1: Add QAChildDetailName validation
    //     if (!qaChildDetailName || !qaChildDetailName.trim()) {
    //         alert("QA Detail Name is required!");
    //         return;
    //     }

    //     if (!selectedWork || !selectedWorkItemDetails) return;

    //     // find full object for the chosen detail
    //     const detailRow = fetchedWorkDetails.find(
    //         (x) => x.Id === selectedWorkItemDetails.value
    //     );
    //     if (!detailRow) return;

    //     const item = {
    //         workId: detailRow.WorkId,
    //         WorkItemId: detailRow.WorkItemId,
    //         WorkDetailsId: detailRow.Id,
    //         UnitofMeasuresId: detailRow.UnitofMeasuresId,

    //         // Sub-task 4.2: Include QAChildDetailName in new item object
    //         QAChildDetailName: qaChildDetailName.trim(),
    //         WorkName: detailRow.WorkName || selectedWork.label,
    //         WorkItemName: detailRow.WorkItemName || "",
    //         WorkdItemName: detailRow.WorkItemName || "", // For display compatibility
    //         Name: detailRow.Name || "",
    //         DetailsName: detailRow.Name || "", // For display compatibility
    //         UOM: detailRow.UOM || "",
    //         UnitofMeasuresId: detailRow.UnitofMeasuresId || "",
    //         Description: detailRow.Description || "",
    //         WorkdDetailsName: detailRow.Description || "", // For display compatibility
    //         WorkDetailsName: detailRow.Description || "", // For display compatibility
    //         Quantity: 1,
    //         Rate: parseFloat(detailRow.Rate || 0),
    //         Amount: parseFloat(detailRow.Rate || 0),
    //         TaxableAmount: parseFloat(detailRow.Rate || 0),
    //         GSTRate: parseFloat(detailRow.GSTRate || 0),
    //         CGSTAmount: 0,
    //         SGSTAmount: 0,
    //         IGSTAmount: 0,
    //         TotalAmount: 0,
    //         Remarks: detailRow.Remarks || "",
    //     };

    //     // Check for duplicates within same QA section and Work group
    //     const qaName = item.QAChildDetailName;
    //     const workName = item.WorkName;

    //     if (
    //         selectedWorkDetails.some(
    //             (x) =>
    //                 x.QAChildDetailName === qaName &&
    //                 x.WorkName === workName &&
    //                 x.WorkDetailsId === item.WorkDetailsId
    //         )
    //     ) {
    //         alert("This work item has already been added to this QA section and Work group.");
    //         return;
    //     }

    //     // compute GST split (CGST/SGST) and Total
    //     const gstAmount = parseFloat(
    //         ((item.Amount * (item.GSTRate || 0)) / 100).toFixed(2)
    //     );
    //     item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    //     item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
    //     item.IGSTAmount = 0;
    //     item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));

    //     // ✅ Append new item to flat array
    //     setSelectedWorkDetails((prev) => [...prev, item]);

    //     // ✅ Manually update groupedData for immediate rendering
    //     const quotationKey = "QuotationDetails";
    //     setGroupedData((prev) => {
    //         const updated = structuredClone(prev || {});

    //         // Initialize nested structure if needed
    //         if (!updated[quotationKey]) updated[quotationKey] = {};
    //         if (!updated[quotationKey][qaName]) updated[quotationKey][qaName] = {};
    //         if (!updated[quotationKey][qaName][workName]) {
    //             updated[quotationKey][qaName][workName] = [];
    //         }

    //         // Add item to nested structure
    //         updated[quotationKey][qaName][workName].push(item);

    //         return updated;
    //     });

    //     // ✅ Auto-expand the newly added group
    //     const expandKey = `${qaName}_${workName}`;
    //     setExpandedGroups((prev) => ({
    //         ...prev,
    //         [expandKey]: true,
    //     }));

    //     // ✅ Clear only item dropdown (keep Work and QA Detail Name for faster adding)
    //     setSelectedWorkItemDetails(null);
    // };

    //GST % LIST 
    const quotationKey = "QuotationDetails";

    const handleAddWork = () => {
        // Sub-task 4.1: Add QAChildDetailName validation
        if (!qaChildDetailName || !qaChildDetailName.trim()) {
            alert("QA Detail Name is required!");
            return;
        }

        if (!selectedWork || !selectedWorkItemDetails) return;

        // find full object for the chosen detail
        const detailRow = fetchedWorkDetails.find(
            (x) => x.Id === selectedWorkItemDetails.value
        );
        if (!detailRow) return;

        // Extract GST rate from dropdown selection, default to formData.GSTRate or 0
        const gstRate = selectedgst?.label
            ? (parseFloat(selectedgst.label.replace('%', '')) || 0)
            : (parseFloat(formData.GSTRate) || 0);

        const item = {
            workId: detailRow.WorkId,
            WorkItemId: detailRow.WorkItemId,
            WorkDetailsId: detailRow.Id,
            UnitofMeasuresId: detailRow.UnitofMeasuresId,

            // Sub-task 4.2: Include QAChildDetailName in new item object
            QAChildDetailName: qaChildDetailName.trim(),
            WorkName: detailRow.WorkName || selectedWork.label,
            WorkItemName: detailRow.WorkItemName || "",
            WorkdItemName: detailRow.WorkItemName || "", // For display compatibility
            Name: detailRow.Name || "",
            DetailsName: detailRow.Name || "", // For display compatibility
            UOM: detailRow.UOM || "",
            UnitofMeasuresId: detailRow.UnitofMeasuresId || "",
            Description: detailRow.Description || "",
            WorkdDetailsName: detailRow.Description || "", // For display compatibility
            WorkDetailsName: detailRow.Description || "", // For display compatibility
            Quantity: 1,
            Rate: parseFloat(detailRow.Rate || 0),
            Amount: parseFloat(detailRow.Rate || 0),
            TaxableAmount: parseFloat(detailRow.Rate || 0),
            GSTRate: gstRate,
            CGSTAmount: 0,
            SGSTAmount: 0,
            IGSTAmount: 0,
            TotalAmount: 0,
            Remarks: detailRow.Remarks || "",
        };

        // Check for duplicates within same QA section and Work group
        const qaName = item.QAChildDetailName;
        const workName = item.WorkName;

        if (
            selectedWorkDetails.some(
                (x) =>
                    x.QAChildDetailName === qaName &&
                    x.WorkName === workName &&
                    x.WorkDetailsId === item.WorkDetailsId
            )
        ) {
            alert("This work item has already been added to this QA section and Work group.");
            return;
        }

        // compute GST split (CGST/SGST) and Total using extracted rate from dropdown
        const gstAmount = parseFloat(
            ((item.Amount * gstRate) / 100).toFixed(2)
        );

        if (isIGST) {
            // IGST mode: full GST goes to IGST
            item.IGSTAmount = gstAmount;
            item.CGSTAmount = 0;
            item.SGSTAmount = 0;
        } else {
            // Normal mode: split between CGST and SGST
            item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
            item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
            item.IGSTAmount = 0;
        }
        item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));

        // ✅ Append new item to flat array
        setSelectedWorkDetails((prev) => [...prev, item]);

        // ✅ Manually update groupedData for immediate rendering
        const quotationKey = "QuotationDetails";
        setGroupedData((prev) => {
            const updated = structuredClone(prev || {});

            // Initialize nested structure if needed
            if (!updated[quotationKey]) updated[quotationKey] = {};
            if (!updated[quotationKey][qaName]) updated[quotationKey][qaName] = {};
            if (!updated[quotationKey][qaName][workName]) {
                updated[quotationKey][qaName][workName] = [];
            }

            // Add item to nested structure
            updated[quotationKey][qaName][workName].push(item);

            return updated;
        });

        // ✅ Auto-expand the newly added group
        const expandKey = `${qaName}_${workName}`;
        setExpandedGroups((prev) => ({
            ...prev,
            [expandKey]: true,
        }));

        // ✅ Clear only item dropdown (keep Work and QA Detail Name for faster adding)
        setSelectedWorkItemDetails(null);
    };


    const [gstOptions, setGstOptions] = useState([]);
    const [selectedgst, setSelectedGst] = useState(null);

    // IGST checkbox state
    const [isIGST, setIsIGST] = useState(false);

    const fetchGSTRate = async () => {
        try {
            const response = await fetchData('QuotationApi', `/GST/${companyId}`, token); //, token
            if (response.responseCode === '1111') {
                const options = response.response_data.map(gst => ({
                    value: gst.Id || 0,
                    label: gst.Name
                }));
                setGstOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleGSTChange = (selectedOption) => {
        setSelectedGst(selectedOption);

        // Extract GST rate from the selected option
        const newGstRate = selectedOption?.label
            ? (parseFloat(selectedOption.label.replace('%', '')) || 0)
            : 0;

        // Update formData with the new GST rate
        setFormData((prev) => ({
            ...prev,
            GSTRate: newGstRate
        }));

        // Recalculate all existing items with the new GST rate
        const quotationKey = "QuotationDetails";
        setGroupedData((prevData) => {
            const updated = structuredClone(prevData || {}); // deep clone

            if (!updated[quotationKey]) return updated;

            // Loop through all QA sections
            Object.keys(updated[quotationKey]).forEach((qaName) => {
                // Loop through all work groups in each QA section
                Object.keys(updated[quotationKey][qaName]).forEach((workName) => {
                    const items = updated[quotationKey][qaName][workName];

                    // Update each item with new GST rate and recalculate
                    items.forEach((item) => {
                        item.GSTRate = newGstRate;

                        // Recalculate GST amounts based on IGST checkbox
                        const gstAmount = parseFloat(((item.Amount * newGstRate) / 100).toFixed(2));
                        if (isIGST) {
                            item.IGSTAmount = gstAmount;
                            item.CGSTAmount = 0;
                            item.SGSTAmount = 0;
                        } else {
                            item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
                            item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
                            item.IGSTAmount = 0;
                        }
                        item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));
                    });
                });
            });

            return updated;
        });

        // Also update selectedWorkDetails array to keep it in sync
        setSelectedWorkDetails((prev) => {
            return prev.map((item) => {
                const gstAmount = parseFloat(((item.Amount * newGstRate) / 100).toFixed(2));
                if (isIGST) {
                    return {
                        ...item,
                        GSTRate: newGstRate,
                        IGSTAmount: gstAmount,
                        CGSTAmount: 0,
                        SGSTAmount: 0,
                        TotalAmount: parseFloat((item.Amount + gstAmount).toFixed(2))
                    };
                } else {
                    return {
                        ...item,
                        GSTRate: newGstRate,
                        CGSTAmount: parseFloat((gstAmount / 2).toFixed(2)),
                        SGSTAmount: parseFloat((gstAmount / 2).toFixed(2)),
                        IGSTAmount: 0,
                        TotalAmount: parseFloat((item.Amount + gstAmount).toFixed(2))
                    };
                }
            });
        });
    };

    // Handle IGST checkbox change
    const handleIGSTChange = (e) => {
        const checked = e.target.checked;
        setIsIGST(checked);

        // Recalculate all existing items with IGST logic
        const quotationKey = "QuotationDetails";
        setGroupedData((prevData) => {
            const updated = structuredClone(prevData || {}); // deep clone

            if (!updated[quotationKey]) return updated;

            // Loop through all QA sections
            Object.keys(updated[quotationKey]).forEach((qaName) => {
                // Loop through all work groups in each QA section
                Object.keys(updated[quotationKey][qaName]).forEach((workName) => {
                    const items = updated[quotationKey][qaName][workName];

                    // Update each item with IGST calculation
                    items.forEach((item) => {
                        const gstRate = parseFloat(item.GSTRate) || 0;
                        const gstAmount = parseFloat(((item.Amount * gstRate) / 100).toFixed(2));

                        if (checked) {
                            // IGST mode: full GST goes to IGST
                            item.IGSTAmount = gstAmount;
                            item.CGSTAmount = 0;
                            item.SGSTAmount = 0;
                        } else {
                            // Normal mode: split between CGST and SGST
                            item.CGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
                            item.SGSTAmount = parseFloat((gstAmount / 2).toFixed(2));
                            item.IGSTAmount = 0;
                        }
                        item.TotalAmount = parseFloat((item.Amount + gstAmount).toFixed(2));
                    });
                });
            });

            return updated;
        });

        // Also update selectedWorkDetails array
        setSelectedWorkDetails((prev) => {
            return prev.map((item) => {
                const gstRate = parseFloat(item.GSTRate) || 0;
                const gstAmount = parseFloat(((item.Amount * gstRate) / 100).toFixed(2));

                if (checked) {
                    return {
                        ...item,
                        IGSTAmount: gstAmount,
                        CGSTAmount: 0,
                        SGSTAmount: 0,
                        TotalAmount: parseFloat((item.Amount + gstAmount).toFixed(2))
                    };
                } else {
                    return {
                        ...item,
                        CGSTAmount: parseFloat((gstAmount / 2).toFixed(2)),
                        SGSTAmount: parseFloat((gstAmount / 2).toFixed(2)),
                        IGSTAmount: 0,
                        TotalAmount: parseFloat((item.Amount + gstAmount).toFixed(2))
                    };
                }
            });
        });
    };

    // ==================================
    // HANDLE UOM CHANGE (no refresh reset)
    // ==================================
    const handleUOMChange = (selectedOption, qaName, workName, index) => {
        const quotationKey = "QuotationDetails";

        // ✅ Update groupedData safely - only update the specific item
        setGroupedData((prevData) => {
            const updated = structuredClone(prevData || {}); // deep clone

            if (!updated[quotationKey]) updated[quotationKey] = {};
            if (!updated[quotationKey][qaName]) updated[quotationKey][qaName] = {};
            if (!Array.isArray(updated[quotationKey][qaName][workName]))
                updated[quotationKey][qaName][workName] = [];

            const targetArray = updated[quotationKey][qaName][workName];

            if (targetArray[index]) {
                targetArray[index] = {
                    ...targetArray[index],
                    UnitofMeasuresId: selectedOption?.value ?? null,
                    UOM: selectedOption?.label ?? "",
                };
            }

            return updated;
        });

        // ✅ ALSO update selectedWorkDetails to keep it in sync
        setSelectedWorkDetails((prev) => {
            return prev.map((item) => {
                if (item.QAChildDetailName === qaName && item.WorkName === workName) {
                    const itemsInGroup = prev.filter(
                        (x) => x.QAChildDetailName === qaName && x.WorkName === workName
                    );
                    const itemIndex = itemsInGroup.indexOf(item);

                    if (itemIndex === index) {
                        return {
                            ...item,
                            UnitofMeasuresId: selectedOption?.value ?? null,
                            UOM: selectedOption?.label ?? "",
                        };
                    }
                }
                return item;
            });
        });
    };

    const handleRemarksChange = (e, qaName, workName, index) => {
        const quotationKey = "QuotationDetails";
        const { value } = e.target;

        // ✅ Update groupedData safely - only update the specific item
        setGroupedData((prevData) => {
            const updated = structuredClone(prevData || {}); // deep clone

            if (!updated[quotationKey]) updated[quotationKey] = {};
            if (!updated[quotationKey][qaName]) updated[quotationKey][qaName] = {};
            if (!Array.isArray(updated[quotationKey][qaName][workName]))
                updated[quotationKey][qaName][workName] = [];

            const targetArray = updated[quotationKey][qaName][workName];

            if (targetArray[index]) {
                targetArray[index] = {
                    ...targetArray[index],
                    Remarks: value,
                };
            }

            return updated;
        });

        // ✅ ALSO update selectedWorkDetails to keep it in sync
        setSelectedWorkDetails((prev) => {
            return prev.map((item) => {
                if (item.QAChildDetailName === qaName && item.WorkName === workName) {
                    const itemsInGroup = prev.filter(
                        (x) => x.QAChildDetailName === qaName && x.WorkName === workName
                    );
                    const itemIndex = itemsInGroup.indexOf(item);

                    if (itemIndex === index) {
                        return {
                            ...item,
                            Remarks: value,
                        };
                    }
                }
                return item;
            });
        });
    };

    const handleItemRemarkChange = (e, qaName, workName, index) => {
        const quotationKey = "QuotationDetails";
        const { value } = e.target;

        setGroupedData((prevData) => {
            const updated = structuredClone(prevData || {});

            if (!updated[quotationKey]) updated[quotationKey] = {};
            if (!updated[quotationKey][qaName]) updated[quotationKey][qaName] = {};
            if (!Array.isArray(updated[quotationKey][qaName][workName]))
                updated[quotationKey][qaName][workName] = [];

            const targetArray = updated[quotationKey][qaName][workName];

            if (targetArray[index]) {
                targetArray[index] = {
                    ...targetArray[index],
                    ItemRemark: value,
                };
            }

            return updated;
        });

        // ✅ ALSO update selectedWorkDetails to keep it in sync
        setSelectedWorkDetails((prev) => {
            return prev.map((item) => {
                if (item.QAChildDetailName === qaName && item.WorkName === workName) {
                    const itemsInGroup = prev.filter(
                        (x) => x.QAChildDetailName === qaName && x.WorkName === workName
                    );
                    const itemIndex = itemsInGroup.indexOf(item);

                    if (itemIndex === index) {
                        return {
                            ...item,
                            ItemRemark: value,
                        };
                    }
                }
                return item;
            });
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (!formData.QuotationNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.CustomerId) {
            setErrorMessage('Customer is required !');
            setIsLoading(false);
            return;
        }


        if (!formData.UnitofMeasuresId) {
            setErrorMessage("UOM is required !");
            setIsLoading(false);
            return;
        }

        //  if (!formData.GSTRate) {
        //     setErrorMessage("GSTRate is required !");
        //     setIsLoading(false);
        //     return;
        // }


        // Extract GST rate from dropdown selection
        const masterGstRate = selectedgst?.label
            ? (parseFloat(selectedgst.label.replace('%', '')) || 0)
            : (parseFloat(formData.GSTRate) || 0);

        // Sub-task 11.1: Flatten nested structure for API
        // Extract all items from nested groupedData structure
        const quotationKey = "QuotationDetails";
        const updatedQuotationDetails = [];

        if (groupedData[quotationKey]) {
            Object.entries(groupedData[quotationKey]).forEach(([qaName, qaGroup]) => {
                Object.entries(qaGroup).forEach(([workName, workItems]) => {
                    // Preserve QAChildDetailName on each item
                    workItems.forEach(item => {
                        updatedQuotationDetails.push({
                            ...item,
                            QAChildDetailName: qaName
                        });
                    });
                });
            });
        }

        // Sub-task 11.2: Format Terms & Conditions for API
        // Transform selectedItems to API format
        // Use QATermsAndConditionId if it exists (already added record), otherwise use Id: 0 (new record)
        // Use selectedItems as the source of truth to avoid duplicates
        console.log('selectedItems before formatting:', selectedItems);

        // Remove duplicates based on Id
        const uniqueSelectedItems = selectedItems.filter((item, index, self) =>
            index === self.findIndex((t) => t.Id === item.Id)
        );

        console.log('uniqueSelectedItems after deduplication:', uniqueSelectedItems);

        const formattedTermsAndConditions = uniqueSelectedItems.map(term => ({
            Id: term.QATermsAndConditionId || 0, // Use existing QATermsAndCondition Id if available, otherwise 0 for new
            QuotationId: parseInt(id), // ✅ Include QuotationId
            TermsAndConditionId: term.Id,
            Name: term.Name,
            IsActive: true,
            CompanyId: companyId
        }));

        console.log('formattedTermsAndConditions:', formattedTermsAndConditions);

        // Include in UpdateData object as QATermsAndCondition
        const UpdateData = {
            Quotation: {
                ...formData,
                CreatedBy: userId,
                CompanyId: companyId,
                IsType: isIGST, // Add IGST flag (IsType field in database)
                GSTRate: masterGstRate
            },
            QuotationDetails: updatedQuotationDetails,
            QATermsAndCondition: formattedTermsAndConditions
        };

        // Sub-task 11.3: Submit data to API
        // Call updateData with formatted data
        updateData('QuotationApi', `${id}`, UpdateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                setIsLoading(false);
                // Navigate to index page on success
                history.push('/QuotationIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setErrorMessage('Error updating quotation. Please try again.');
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData('QuotationApi', `/Quotation/${id}`, token) //, token
            .then((response) => {
                if (response.responseCode === '1111') {
                    const responseData = response.response_data;

                    // Set form data
                    setFormData(responseData.Quotation);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    // Set IGST checkbox state from loaded data (IsType field in database)
                    if (responseData.Quotation.IsType !== undefined) {
                        setIsIGST(responseData.Quotation.IsType);
                    }

                    // Set selected customer based on loaded quotation
                    if (responseData.Quotation.CustomerId && CustomerOptions.length > 0) {
                        const matchingCustomer = CustomerOptions.find(
                            (option) => option.value === responseData.Quotation.CustomerId
                        );
                        if (matchingCustomer) {
                            setSelectedCustomer(matchingCustomer);
                        }
                    }

                    // Extract and set QuotationDetails
                    const quotationDetails = responseData.QuotationDetails || [];

                    // Normalize field names for consistency
                    const normalizedDetails = quotationDetails.map(item => ({
                        ...item,
                        // Ensure all required fields exist with consistent naming
                        WorkItemName: item.WorkItemName || item.WorkdItemName || "",
                        DetailsName: item.DetailsName || item.Name || "",
                        WorkDetailsName: item.WorkDetailsName || item.WorkdDetailsName || item.Description || "",
                        Name: item.Name || item.DetailsName || "",
                        Description: item.Description || item.WorkDetailsName || item.WorkdDetailsName || "",
                    }));

                    setSelectedWorkDetails(normalizedDetails);

                    // Transform flat QuotationDetails to nested structure grouped by QAChildDetailName and WorkName
                    const quotationKey = "QuotationDetails";
                    const nested = { [quotationKey]: {} };

                    normalizedDetails.forEach(item => {
                        const qaName = item.QAChildDetailName || "Uncategorized";
                        const workName = item.WorkName;

                        if (!nested[quotationKey][qaName]) {
                            nested[quotationKey][qaName] = {};
                        }
                        if (!nested[quotationKey][qaName][workName]) {
                            nested[quotationKey][qaName][workName] = [];
                        }

                        nested[quotationKey][qaName][workName].push(item);
                    });

                    setGroupedData(nested);

                    // Extract QATermsAndCondition from API response
                    const qaTermsAndCondition = responseData.QATermsAndCondition || [];
                    console.log('Loaded QATermsAndCondition from API:', qaTermsAndCondition);

                    // Initialize selectedItems state with existing terms based on TermsAndConditionId matching
                    // This is the single source of truth for selected Terms & Conditions
                    // Store both the TermsAndConditionId (for checkbox matching) and QATermsAndConditionId (for update)
                    const existingTerms = qaTermsAndCondition.map(term => ({
                        Id: term.TermsAndConditionId, // Map TermsAndConditionId to Id for checkbox matching
                        QATermsAndConditionId: term.Id, // Store the QATermsAndCondition Id for updates
                        Name: term.Name,
                        CompanyId: companyId
                    }));
                    console.log('Mapped existingTerms:', existingTerms);
                    setSelectedItems(existingTerms);

                    // Set selectedGst based on GSTRate from loaded quotation
                    if (responseData.Quotation.GSTRate && gstOptions.length > 0) {
                        const gstRateValue = parseFloat(responseData.Quotation.GSTRate);
                        const matchingGstOption = gstOptions.find((option) => {
                            const optionRate = parseFloat(option.label.replace('%', '')) || 0;
                            return optionRate === gstRateValue;
                        });
                        if (matchingGstOption) {
                            setSelectedGst(matchingGstOption);
                        }
                    }

                    // Set selecteduom based on UnitofMeasuresId from loaded quotation
                    if (responseData.Quotation.UnitofMeasuresId && UomOptions.length > 0) {
                        const matchingUomOption = UomOptions.find(
                            (option) => option.value === responseData.Quotation.UnitofMeasuresId
                        );
                        if (matchingUomOption) {
                            setSelecteduom(matchingUomOption);
                        }
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id, token, userId, companyId, gstOptions, CustomerOptions, UomOptions]);

    // Synchronize selectedgst when formData.GSTRate and gstOptions are available
    useEffect(() => {
        if (formData.GSTRate && gstOptions.length > 0 && !selectedgst) {
            const gstRateValue = parseFloat(formData.GSTRate);
            const matchingGstOption = gstOptions.find((option) => {
                const optionRate = parseFloat(option.label.replace('%', '')) || 0;
                return optionRate === gstRateValue;
            });
            if (matchingGstOption) {
                setSelectedGst(matchingGstOption);
            }
        }
    }, [formData.GSTRate, gstOptions, selectedgst]);

    // Synchronize selecteduom when formData.UnitofMeasuresId and UomOptions are available
    useEffect(() => {
        if (formData.UnitofMeasuresId && UomOptions.length > 0) {
            const matchingUomOption = UomOptions.find(
                (option) => option.value === formData.UnitofMeasuresId
            );
            if (matchingUomOption) {
                setSelecteduom(matchingUomOption);
            }
        }
    }, [formData.UnitofMeasuresId, UomOptions]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    // -------------------- UI (your return, minimally adjusted) --------------------

    // -------------------- UI (your return, minimally adjusted) --------------------

    return (
        <div
            style={{
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "12px",
                width: "100%",
                padding: "5px",
                marginTop: '-15px'
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "6px",
                    marginBottom: "12px"
                }}
            >
                <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                    Quotation Edit
                </h6>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "300px repeat(3, 1fr)",
                        gap: "10px",
                        marginBottom: "12px",
                        alignItems: "end",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", width: "500px" }}>
                        {/* Label + Type */}
                        <label style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            marginRight: "8px",
                            whiteSpace: "nowrap",
                            color: 'red',
                            marginLeft: '-150px'
                        }}>
                            Customer
                            <span style={{ color: "black", marginLeft: "8px" }}>
                                (GST No: {fetchedCustomerDetails[0]?.GSTNumber || "-"})
                            </span>
                        </label>

                        {/* Select Dropdown */}
                        <div style={{ flexGrow: 1 }}>
                            <Select
                                value={selectedCustomer}
                                onChange={handleCustomerChange}
                                options={CustomerOptions}
                                placeholder="Select Customer"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "28px",
                                        height: "28px",
                                        fontSize: "12px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "28px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "28px",
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                        fontSize: "12px",
                                    }),
                                }}
                            />
                        </div>
                    </div>

                </div>

                <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0 }}>
                    {/* Terms & Conditions Button */}
                    <Button
                        variant="contained"
                        onClick={LoadTermsAndConditions}
                        style={{
                            height: "25px",
                            minWidth: "80px",
                            borderRadius: "6px",
                            backgroundColor: "#885b09ff",
                            color: "#FFFFFF",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e09b4dff")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#885b09ff")}
                    >
                        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Terms & Conditions"}
                    </Button>

                    {/* Terms & Conditions Modal */}
                    {isModalGrpOpen && (
                        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                            <div
                                className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto animate-zoomIn"
                            >
                                {/* Header with Close Button */}
                                <div className="flex justify-between items-center mb-4 border-b pb-2">
                                    <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                                        Terms & Conditions
                                    </h6>
                                    <IconButton onClick={handleCloseModal}>
                                        <CloseIcon />
                                    </IconButton>
                                </div>

                                {/* Table Section */}
                                <div
                                    className="w-full"
                                    style={{ maxHeight: "520px", overflowY: "auto", width: "100%", marginTop: '-15px' }}
                                >
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            maxHeight: 400,
                                            border: "1px solid #f4dfdf",
                                        }}
                                    >
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: "#0f3460" }}>
                                                    <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}></TableCell>
                                                    <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}>Sl.No</TableCell>
                                                    <TableCell sx={{ color: "white", fontWeight: "bold", padding: '3px', backgroundColor: "#071b33ff", fontSize: "12px" }}>Name</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {data && data.length > 0 ? (
                                                    data.map((item, index) => (
                                                        <TableRow
                                                            key={item.Id || index}
                                                            sx={{
                                                                "&:hover": { backgroundColor: "#F1E7E7" },
                                                                transition: "background-color 0.3s ease-in-out",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            {/* Checkbox column */}
                                                            <TableCell
                                                                sx={{
                                                                    padding: "2px",
                                                                    width: "5%",
                                                                    borderRight: "1px solid #f4dfdf",
                                                                }}
                                                            >
                                                                <Checkbox
                                                                    checked={isItemSelected(item)}
                                                                    onChange={() => handleCheckboxChange(item)}
                                                                    color="primary"
                                                                    size="small"
                                                                />
                                                            </TableCell>

                                                            {/* Serial No */}
                                                            <TableCell
                                                                sx={{
                                                                    padding: "4px",
                                                                    borderRight: "1px solid #f4dfdf",
                                                                    fontSize: "12px",
                                                                    width: "10%",
                                                                }}
                                                            >
                                                                {index + 1}
                                                            </TableCell>

                                                            {/* Name */}
                                                            <TableCell
                                                                sx={{
                                                                    padding: "4px",
                                                                    fontSize: "12px",
                                                                }}
                                                            >
                                                                {item.Name}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={3} align="center" sx={{ padding: "20px" }}>
                                                            {isLoading ? "Loading..." : "No terms found."}
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Update Button */}
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{
                            height: "25px",
                            minWidth: "80px",
                            borderRadius: "6px",
                            backgroundColor: "#1E3A8A", // deep ERP-blue
                            color: "#FFFFFF",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#1E3A8A")}
                    >
                        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Update"}
                    </Button>

                    {/* Back To List Button */}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/QuotationIndex"
                        className="linkcolor"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#F3F4F6", // light gray ERP style
                            color: "#1E3A8A",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {/* <div className="grid grid-cols-12 gap-1 p-4 mb-3 rounded-lg bg-gray-100 -mt-2" style={{ marginTop: '-20px', background: '#F1F0E9' }}> */}
            <div
                style={{
                    display: "grid",
                    // gridTemplateColumns: "250px repeat(7, 1fr)", 
                    gridTemplateColumns: "repeat(10, 1fr)",
                    gap: "10px",
                    marginBottom: "12px",
                    alignItems: "end" // ✅ aligns all inputs properly
                }}
            >
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>QA Date</label>
                    <input
                        type="date"
                        name="QuotationDate"
                        value={formData.QuotationDate ? formData.QuotationDate.split('T')[0] : ''}
                        onChange={handleInputChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600", color: 'red' }}>
                        QA No
                    </label>
                    <input
                        type="text"
                        name="QuotationNumber"
                        value={formData.QuotationNumber}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Amount</label>
                    <input
                        type="number"
                        name="Amount"
                        value={formData.Amount}
                        onChange={handleChange}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>TaxableAmount</label>
                    <input
                        type="number"
                        name="TaxableAmount"
                        value={formData.TaxableAmount}
                        onChange={handleChange}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>CGSTAmount</label>
                    <input
                        type="number"
                        name="CGSTAmount"
                        value={formData.CGSTAmount}
                        onChange={handleChange}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>SGSTAmount</label>
                    <input
                        type="number"
                        name="SGSTAmount"
                        value={formData.SGSTAmount}
                        onChange={handleChange}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>IGSTAmount</label>
                    <input
                        type="number"
                        name="IGSTAmount"
                        value={formData.IGSTAmount}
                        onChange={handleChange}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>RoundOff</label>
                    <input
                        type="number"
                        name="RoundOff"
                        value={formData.RoundOff}
                        onChange={handleChange}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>TotalAmount</label>
                    <input
                        type="number"
                        name="TotalAmount"
                        value={formData.TotalAmount}
                        onChange={handleChange}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>GrandTotal</label>
                    <input
                        type="number"
                        name="GrandTotal"
                        value={formData.GrandTotal}
                        onChange={handleChange}
                        disabled
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                {/* ---------------- Row 3 - Bill Header Section ---------------- */}

                <div className="col-span-12 md:col-span-2">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Work Name</label>
                    <input
                        type="text"
                        name="WorkName"
                        value={formData.WorkName}
                        onChange={handleChange}
                        placeholder="Enter Work Name"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-2">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Bill Header</label>
                    <input
                        type="text"
                        name="Description"
                        value={formData.Description}
                        onChange={handleChange}
                        placeholder="Enter Description"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-3">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Remarks</label>
                    <input
                        type="text"
                        name="Remarks"
                        value={formData.Remarks}
                        onChange={handleChange}
                        placeholder="Enter Remarks"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-1">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>HSN Code</label>
                    <input
                        type="text"
                        name="HSNCode"
                        value={formData.HSNCode || ''}
                        onChange={handleChange}
                        placeholder="HSN"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-1">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>UOM</label>
                    <Select
                        value={selecteduom}
                        onChange={(selectedOption) => {
                            setSelecteduom(selectedOption);
                            setFormData((prev) => ({
                                ...prev,
                                UnitofMeasuresId: selectedOption?.value || "",
                            }));
                        }}
                        options={UomOptions}
                        placeholder="UOM"
                        isSearchable
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: "30px",
                                height: "30px",
                                fontSize: "14px",
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                height: "30px",
                                padding: "0 6px",
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: "30px",
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                                fontSize: "14px",
                            }),
                        }}
                    />
                </div>

                {/* GST Rate Dropdown */}
                <div className="col-span-12 md:col-span-1">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>GST %</label>
                    <Select
                        value={selectedgst}
                        onChange={handleGSTChange}
                        options={gstOptions}
                        placeholder="GST %"
                        isSearchable
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: "30px",
                                height: "30px",
                                fontSize: "14px",
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                height: "30px",
                                padding: "0 6px",
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: "30px",
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                                fontSize: "14px",
                            }),
                        }}
                    />
                </div>

            </div>

            {/* ---------------- Row 4 - Work Details Section ---------------- */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(12, 1fr)",
                    gap: "10px",
                    marginBottom: "12px",
                    alignItems: "end"
                }}
            >

                {/* IGST Checkbox */}
                <div className="col-span-12 md:col-span-1" style={{ display: "flex", alignItems: "center", paddingTop: "20px" }}>
                    <Checkbox
                        checked={isIGST}
                        onChange={handleIGSTChange}
                        color="primary"
                        size="small"
                        style={{ padding: "0 4px" }}
                    />
                    <label style={{ fontSize: "11px", fontWeight: "600", marginLeft: "4px" }}>Is IGST?</label>
                </div>


                {/* QA Detail Name Input Field */}
                <div className="col-span-12 md:col-span-2">
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        QA Detail Name<span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                        type="text"
                        value={qaChildDetailName}
                        onChange={(e) => setQaChildDetailName(e.target.value)}
                        placeholder="Enter QA Detail Name"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "14px",
                            height: "30px",
                            width: "100%",
                            padding: "0 6px",
                        }}
                    />
                </div>

                {/* Work & Details */}
                <div className="col-span-12 md:col-span-2">
                    <label className="block uppercase text-[10px] font-bold mb-1 font-mono text-black" style={{ fontSize: '12.5px' }}>
                        Work<span className="text-red-500">*</span>
                    </label>
                    <Select
                        value={selectedWork}
                        onChange={handleWorkChange}
                        options={WorkOptions}
                        placeholder="Work"
                        isSearchable
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: "30px",
                                height: "30px",
                                fontSize: "14px",
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                height: "30px",
                                padding: "0 6px",
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: "30px",
                            }),
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                                fontSize: "14px",
                            }),
                        }}
                    />
                </div>

                <div className="col-span-12 md:col-span-6">
                    <label className="block uppercase text-[10px] font-bold mb-1 font-mono text-black" style={{ fontSize: '12.5px' }}>
                        Details
                    </label>
                    <div className="flex items-center gap-2">
                        <div className="w-full">
                            <Select
                                value={selectedWorkItemDetails}
                                onChange={handleWorkItemDetailsChange}
                                options={workitemdetailsOptions}
                                placeholder="Work Details"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                        fontSize: "14px",
                                    }),
                                }}
                            />
                        </div>

                        <button
                            onClick={handleAddWork}
                            className="w-20 h-8 text-[11px] font-bold text-white rounded shadow transition-transform duration-150 ease-in-out"
                            style={{ backgroundColor: "#2294a5ff" }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.04)";
                                e.currentTarget.style.backgroundColor = "#224f02ff";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.backgroundColor = "#2294a5ff";
                            }}
                        >
                            <span style={{ fontSize: '12.5px' }}>ADD</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Grouped Table */}
            {
                Object.keys(filteredGroupedData).length > 0 && (
                    <div className="mb-2"
                        style={{
                            maxHeight: "430px",
                            overflowY: "auto",
                            overflowX: "auto",
                            marginBottom: "12px",
                            border: "1px solid #999",
                            borderRadius: "4px",
                            backgroundColor: "#fff",
                            width: "100%",
                        }}>
                        {/* <TableContainer component={Paper}> */}
                        <table
                            style={{
                                minWidth: "1700px",
                                width: "100%",
                                borderCollapse: "collapse",
                                fontSize: "13px",
                                fontFamily: "monospace",
                                tableLayout: "fixed",
                            }}
                        >
                            <thead
                                style={{
                                    backgroundColor: "#1F2A38",
                                    color: "#FFFFFF",
                                    position: "sticky",
                                    top: 0, // ← must include top
                                    zIndex: 2, // ← ensures it stays above table body
                                }}
                            >
                                <TableRow>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '60px', minWidth: '60px', textAlign: 'left', position: 'sticky', left: '0', backgroundColor: '#1F2A38', zIndex: '3' }}>Sl.No</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '400px', minWidth: '400px', textAlign: 'left', position: 'sticky', left: '60px', backgroundColor: '#1F2A38', zIndex: '3' }}>Description</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '100px', minWidth: '100px', textAlign: 'left' }}>UOM</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '100px', minWidth: '100px', textAlign: 'center' }}>QTY</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>RATE</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>AMOUNT</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>TAXABLE</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>GST ₹</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '120px', minWidth: '120px', textAlign: 'center' }}>TOTAL</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '180px', minWidth: '180px', textAlign: 'left' }}>Remarks</TableCell>
                                    <TableCell style={{ fontSize: '11px', padding: '4px', color: 'whitesmoke', textTransform: 'uppercase', fontWeight: 'bolder', width: '180px', minWidth: '180px', textAlign: 'left' }}>Item Remark</TableCell>
                                </TableRow>
                            </thead>


                            <TableBody>
                                {/* Sub-task 9.1: Add QA section headers */}
                                {Object.entries(filteredGroupedData).map(([qaName, qaGroup]) => (
                                    <React.Fragment key={qaName}>
                                        {/* QA HEADER - Render QA Child Detail Name headers with distinct styling */}
                                        <tr style={{ backgroundColor: "#CBD99B", textAlign: 'center' }}>
                                            <td
                                                colSpan={11}
                                                style={{
                                                    fontWeight: "bold",
                                                    fontSize: "13px",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {qaName}
                                            </td>
                                        </tr>
                                        {/* Sub-task 9.2: Update work group rendering - Nest work groups under QA sections */}
                                        {Object.entries(qaGroup).map(([workName, items]) => (
                                            <React.Fragment key={workName}>
                                                {/* Work Group Header Row - Update toggle functionality to use "qaName_workName" keys */}
                                                <tr
                                                    onClick={() => toggleGroup(qaName, workName)}
                                                    style={{
                                                        backgroundColor: "#f3ecd9",
                                                        cursor: "pointer",
                                                        textTransform: 'uppercase',
                                                    }}
                                                >
                                                    <td colSpan={11} style={{ fontWeight: "bold" }}>
                                                        {workName}{" "}
                                                        <span style={{ float: "right" }}>
                                                            {expandedGroups[`${qaName}_${workName}`] ? "▲" : "▼"}
                                                        </span>
                                                    </td>
                                                </tr>

                                                {/* Sub-task 9.3: Update work item row rendering */}
                                                {/* Group Items - Pass qaName to all handler functions */}
                                                {expandedGroups[`${qaName}_${workName}`] && items.map((item, index) => (
                                                    <TableRow key={`${qaName}-${workName}-${index}`} style={{
                                                        backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                        borderBottom: '1px solid #E0E0E0',
                                                    }}>
                                                        <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '2px', textAlign: 'left', width: '60px', position: 'sticky', left: '0', backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF', zIndex: '1' }}>
                                                            {index + 1}
                                                            <Tooltip title="Delete Item">
                                                                <DeleteIcon
                                                                    style={{ color: 'brown', cursor: 'pointer', marginLeft: '20px', fontSize: '19px' }}
                                                                    onClick={() => deleteItem(qaName, workName, index)}
                                                                />
                                                            </Tooltip>
                                                        </td>

                                                        {/* Description column - unified handling */}
                                                        <td style={{ fontSize: '10.5px', padding: '3px', width: '400px', borderRight: '1px solid #E0E0E0', position: 'sticky', left: '60px', backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF', zIndex: '1' }}>
                                                            <span style={{ color: 'blue' }}>{item.DetailsName || item.Name || ""}</span>
                                                            {(item.DetailsName || item.Name) && " / "}
                                                            {item.WorkDetailsName || item.Description || ""}
                                                        </td>

                                                        {/* UOM column */}
                                                        <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '7%' }}>
                                                            <Select
                                                                value={item.UOM ? { value: item.UnitofMeasuresId, label: item.UOM } : null}
                                                                onChange={(selectedOption) => handleUOMChange(selectedOption, qaName, workName, index)}
                                                                options={UomOptions}
                                                                placeholder="UOM"
                                                                isSearchable
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: "25px",
                                                                        height: "25px",
                                                                        fontSize: "12px",
                                                                    }),
                                                                    valueContainer: (base) => ({
                                                                        ...base,
                                                                        height: "25px",
                                                                        padding: "0 6px",
                                                                    }),
                                                                    indicatorsContainer: (base) => ({
                                                                        ...base,
                                                                        height: "25px",
                                                                    }),
                                                                    menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                                                                    menu: (provided) => ({
                                                                        ...provided,
                                                                        fontSize: "12px",
                                                                    }),
                                                                }}
                                                            />
                                                        </td>

                                                        <td style={{ padding: '3px', textAlign: 'right', width: '80px' }}>
                                                            <input
                                                                type="number"
                                                                name="Quantity"
                                                                value={item.Quantity}
                                                                onChange={(e) => handleCalculation(e, qaName, workName, index, 'Quantity')}
                                                                onClick={(e) => e.target.select()}
                                                                style={{
                                                                    width: "100%",
                                                                    textAlign: "right",
                                                                    border: "1px solid #bbb",
                                                                    borderRadius: "3px",
                                                                    padding: "2px",
                                                                }}
                                                            />
                                                        </td>

                                                        <td style={{ padding: '3px', textAlign: 'right', width: '90px' }}>
                                                            <input
                                                                type="number"
                                                                name="Rate"
                                                                value={item.Rate || 0}
                                                                onChange={(e) => handleCalculation(e, qaName, workName, index, 'Rate')}
                                                                onClick={(e) => e.target.select()}
                                                                style={{
                                                                    width: "100%",
                                                                    textAlign: "right",
                                                                    border: "1px solid #bbb",
                                                                    borderRadius: "3px",
                                                                    padding: "2px",
                                                                }}
                                                            />
                                                        </td>

                                                        <td style={{ padding: '3px', textAlign: 'right', width: '90px' }}>
                                                            <input
                                                                type="number"
                                                                value={item.Amount || 0}
                                                                disabled
                                                                style={{
                                                                    width: "100%",
                                                                    textAlign: "right",
                                                                    border: "1px solid #bbb",
                                                                    borderRadius: "3px",
                                                                    padding: "2px",
                                                                }}
                                                            />
                                                        </td>

                                                        <td style={{ padding: '3px', textAlign: 'right', width: '90px' }}>
                                                            <input
                                                                type="number"
                                                                value={item.TaxableAmount || 0}
                                                                disabled
                                                                style={{
                                                                    width: "100%",
                                                                    textAlign: "right",
                                                                    border: "1px solid #bbb",
                                                                    borderRadius: "3px",
                                                                    padding: "2px",
                                                                }}
                                                            />
                                                        </td>
                                                        <td style={{ padding: '3px', textAlign: 'right', width: '90px' }}>
                                                            <input
                                                                value={
                                                                    parseFloat(item.CGSTAmount) +
                                                                    parseFloat(item.SGSTAmount) +
                                                                    parseFloat(item.IGSTAmount)
                                                                }
                                                                readOnly
                                                                style={{
                                                                    width: "70%",
                                                                    textAlign: "right",
                                                                    border: "1px solid #ccc",
                                                                    borderRadius: "3px",
                                                                    padding: "2px",
                                                                    // fontWeight: "bold",
                                                                }}
                                                            />
                                                            <span
                                                                style={{
                                                                    marginLeft: "4px",
                                                                    color: "darkmagenta",
                                                                    fontSize: "11px",
                                                                    //fontWeight: "bold",
                                                                }}
                                                            >
                                                                {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                                            </span>
                                                        </td>

                                                        <td style={{ padding: '3px', textAlign: 'right', width: '90px' }}>
                                                            <input
                                                                type="number"
                                                                value={item.TotalAmount || 0}
                                                                disabled
                                                                style={{
                                                                    width: "100%",
                                                                    textAlign: "right",
                                                                    border: "1px solid #bbb",
                                                                    borderRadius: "3px",
                                                                    padding: "2px",
                                                                }}
                                                            />
                                                        </td>

                                                        <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '15%', borderRight: '1px solid #E0E0E0', }}>
                                                            <textarea
                                                                value={item.Remarks || ""}
                                                                rows={1} // ✅ use 'rows', not 'row'
                                                                name="Remarks"
                                                                onChange={(e) => handleRemarksChange(e, qaName, workName, index)}
                                                                style={{
                                                                    width: "100%",
                                                                    textAlign: "left",
                                                                    border: "1px solid #bbb",
                                                                    borderRadius: "3px",
                                                                    padding: "2px",
                                                                    resize: "vertical", // ✅ allows manual resizing
                                                                    fontSize: "11px",
                                                                    fontWeight: "bold",
                                                                }}
                                                            />
                                                        </td>

                                                        <td style={{ fontSize: '11px', fontWeight: 'bold', padding: '3px', width: '15%', borderRight: '1px solid #E0E0E0', }}>
                                                            <textarea
                                                                value={item.ItemRemark || ""}
                                                                rows={1}
                                                                name="ItemRemark"
                                                                onChange={(e) => handleItemRemarkChange(e, qaName, workName, index)}
                                                                style={{
                                                                    width: "100%",
                                                                    textAlign: "left",
                                                                    border: "1px solid #bbb",
                                                                    borderRadius: "3px",
                                                                    padding: "2px",
                                                                    resize: "vertical",
                                                                    fontSize: "11px",
                                                                    fontWeight: "bold",
                                                                }}
                                                            />
                                                        </td>
                                                    </TableRow>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </table>
                        {/* </TableContainer> */}
                    </div>

                )
            }
        </div >
    );
};


export default QuotationEdit;
